import { imageList } from "@/core/utils/imageList";
import "./MobileMenu.scss";
import Sidebar from "../../sidebar/Sidebar";
import { ROUTES } from "@/core/constants/app";
import { logoutRequested } from "@/features/auth/store/auth";
import { useCallback, useState } from "react";
import { $userBasicInfo, $userProfile } from "@/features/user/store";
import { Link, useLocation } from "react-router-dom";
import { useUnit } from "effector-react";
import { $unreadNotificationsCount } from "@/features/notifications";
import { SvgIcon } from "@/core/components/svgIcon/SvgIcon";
import { BgImage } from "@/core/components/bgImage/BgImage";
import { setIsMobileNavOpen } from "@/core/store/app";
export const MobileMenu = () => {
  const location = useLocation();
  const [isNotificationsModalOpen, setIsNotificationsModalOpen] =
    useState(false);
  const userProfile = useUnit($userProfile);

  // Get user avatar from profile

  const mainNavItems = [
    {
      path: ROUTES.HOME,
      label: "Home",
      icon: "icon-home",
      active: location.pathname === ROUTES.HOME,
      isPro: false,
    },
    {
      path: ROUTES.CALLS,
      label: "Calls",
      icon: "icon-calls",
      badge: "23",
      badgeType: "primary",
      active: location.pathname === ROUTES.CALLS,
      isPro: false,
    },
    {
      path: ROUTES.PARTNERS,
      label: "Partners",
      icon: "icon-partners",
      active: location.pathname === ROUTES.PARTNERS,
      isPro: false,
    },
    {
      path: ROUTES.IDEAS,
      label: "Ideas",
      icon: "icon-ideas",
      badge: "5",
      active: location.pathname === ROUTES.IDEAS,
      isPro: false,
    },
    {
      path: ROUTES.GOALS,
      label: "Goals",
      icon: "icon-goals",
      active: location.pathname === ROUTES.GOALS,
      isPro: true,
    },
    {
      path: ROUTES.CHAT_INBOX,
      label: "Chat",
      icon: "icon-message",
      active: location.pathname === ROUTES.GOALS,
      isPro: true,
    },
  ];

  const handleLogout = () => {
    logoutRequested();
  };

  const handleNotificationsClick = useCallback(() => {
    setIsNotificationsModalOpen((prev) => !prev);
  }, []);

  const handleNotificationsClose = useCallback(() => {
    setIsNotificationsModalOpen(false);
  }, []);

  return (
    <div className="mobileMenu">
      <div
        className="closeModal"
        onClick={() => {
          setIsMobileNavOpen(false);
        }}
      >
        <SvgIcon icon="icon-closeModal" />
      </div>
      <div className="container">
        <div className="logo">
          <img src={imageList.logo} alt="EU Calls" />
        </div>
        <div className="menu">
          {mainNavItems.map((item) => {
            // if (item.isPro && !pro_user) return <></>;
            return (
              <Link
                to={item.path}
                key={item.path}
                className={`nav-item ${item.active ? "active" : ""}`}
              >
                <div className="nav-icon">
                  <SvgIcon icon={item.icon} />
                </div>
                <div className="">{item.label}</div>
              </Link>
            );
          })}
        </div>
        <Link to={"/settings"} className="settings">
          <div className="user-avatar">
            <BgImage
              img={
                userProfile &&
                typeof userProfile.user_data.user_picture === "object" &&
                userProfile?.user_data?.user_picture?.[0]?.url
                  ? userProfile.user_data.user_picture?.[0]?.url
                  : imageList.noimage
              }
            />
          </div>
          <span>Profile and settings</span>
        </Link>
        <div className="footer-item logout-item" onClick={handleLogout}>
          <div className="footer-icon-wrapper">
            <SvgIcon icon="icon-logout" />
          </div>
          <span>Logout</span>
        </div>
      </div>
    </div>
  );
};
